/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_TitleInputs */

const zh_password_title = /** @type {(inputs: Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码设置`)
};

const en_password_title = /** @type {(inputs: Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password Setup`)
};

const es_password_title = /** @type {(inputs: Password_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de contraseña`)
};

/**
* | output |
* | --- |
* | "Password Setup" |
*
* @param {Password_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_title = /** @type {((inputs?: Password_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_password_title(inputs)
	if (locale === "en") return en_password_title(inputs)
	return es_password_title(inputs)
});